export class JobItemsJobIdreq{
    
    forkLiftJobId?:number;
    jobId?:number

    constructor(forkLiftJobId?:number,jobId?:number){
        this.forkLiftJobId =forkLiftJobId
        this.jobId = jobId
    }

}